import { createContext } from 'react';

const ToolContext = createContext();

export default ToolContext;